import { store } from "../redux/store/Store";
import {
  webSocketUpdatedEvent,
  // refreshAircraftFlights,
  websocketUpdatedFlightEvents,
} from "../redux/actions/flights/FlightWebsocket.Actions";
import { webSocketUpdatePairingEvent } from "../redux/actions/CrewSchedule/PairingWebsocket.Actions";
import {
  WebsocketMessageType,
  IFileReadyNotification,
  IAircraftStateUpdate,
  IAircraftLastStatus,
  IRefreshQualifications,
  IWebsocketAircraftMaintenanceUpdate,
  IGendecSettingsWire,
} from "@vmosolutions/oc-interfaces";
import {
  webSocketUpdatedFlightScannerResults,
  websocketUpdatedFlightErrors,
} from "../redux/actions/flights/FlightScanner.Actions";
import { updateBulkBatch, updateWaterfall } from "../redux/actions/flights/BulkOperations.Actions";
import {
  getCustomerStructures,
  gotAircraftStatus,
  gotAircraftMaintenanceUpdate,
} from "../redux/actions/Structure.Actions";
import { webSocketUpdateNFAEvent } from "../redux/actions/CrewSchedule/NFAWebsocket.Actions";
import { webSocketUpdatePlannedPairingEvent } from "../redux/actions/CrewSchedule/PlannedEventsWebsocket.Actions";
import { websocketUpdatedBooking } from "../redux/actions/CrewTravel/CrewTravelWebsocket.Actions";
import { setAuditFromLink } from "../redux/actions/Audit/Audit.Actions";
import { websocketUpdatedCLM } from "../redux/actions/CrewSchedule/CrewDayLogicModifier.Actions";
import { closeModal, openModal, openSnackbar } from "../redux/actions/App.Actions";
import { loadGendecConfig, setGendecConfig, setGendecStale } from "../redux/actions/Gendec/Gendec.Actions";
import { getQualifications, getViolations } from "../API/CrewScheduleErrors";
import { gotViolationCheckStatus } from "src/redux/actions/CrewSchedule/CrewSchedule.Actions";
import { updatePackageBidPairingCreationProgress } from "src/redux/actions/Bidding.Actions";
import { fetchDispatchDesks } from "src/redux/reducers/DispatchDeskReducer";
import { getEventsByFlight } from "src/redux/reducers/OpsLinkReducer";
import { getPendingByFlight } from "src/redux/reducers/PendingReducer";
import { applyFlightPairingStatusUpdate } from "src/redux/actions/FlightPairingStatusV2/FlightPairingStatusV2.Actions";
import { FLIGHT_PAIRING_STATUS_UPDATE_MESSAGE_TYPE } from "src/pages/FlightPairingStatusV2/pairingStatusTypes";

export function onMessage(e: MessageEvent): void {
  const data = JSON.parse(e.data);
  // console.log(data);
  switch (data.updateType) {
    case WebsocketMessageType.Heartbeat:
      break;

    /*
    Deprecated code, remove once new flight builder template endpoints are confirmed as working.
    case WebsocketMessageType.UpdateFlightBuilderTemplates:
      store.dispatch(updateFlightBuilderTemplates(data.templates));
      break;
    case WebsocketMessageType.DeleteFlightBuilderTemplates:
      store.dispatch(deleteFlightBuilderTemplates(data.templateIds));
      break;
    */

    // New Aircraft Status Updates
    case WebsocketMessageType.AircraftStatusUpdate: {
      if ((data?.data as IAircraftStateUpdate)?.acid) {
        const result = data?.data as IAircraftStateUpdate;
        const aircraftID = result.acid;
        // If available, use updateAt from state update, otherwise use current time.
        const lastUpdated = result?.state?.updatedAt
          ? new Date(result?.state?.updatedAt)?.valueOf()
          : new Date()?.valueOf();
        const lastKnownStatus = store.getState()?.structures?.aircraftStatus?.[aircraftID];
        const milliSinceLastUpdate = lastKnownStatus?.lastUpdated ? lastUpdated - lastKnownStatus?.lastUpdated : 0;
        // spread last known status with current and add addition properties.
        const updatedStatus: IAircraftLastStatus = {
          ...lastKnownStatus,
          ...{ ...result, lastUpdated, milliSinceLastUpdate },
        };
        // Update aircraft status.
        store.dispatch(gotAircraftStatus({ [aircraftID]: updatedStatus }, aircraftID));
      }
      break;
    }
    // case WebsocketMessageType.UpdateAircraftEvents:
    //   store.dispatch(refreshAircraftFlights(data.aircraftsToUpdate));
    //   break;
    case WebsocketMessageType.BasicFlightUpdate:
    case WebsocketMessageType.BasicGroundEventUpdate:
      store.dispatch(webSocketUpdatedEvent(data.updatedEvents, data.updateType));
      break;
    case WebsocketMessageType.BasicFlightEventsUpdate:
      store.dispatch(websocketUpdatedFlightEvents(data.updatedEvents, WebsocketMessageType.BasicFlightUpdate));
      break;
    case WebsocketMessageType.FlightScannerNotification:
      void store.dispatch(
        // @ts-ignore
        webSocketUpdatedFlightScannerResults(data.message.isFlightScannerFinished)
      );
      break;
    case WebsocketMessageType.BulkOperation:
      store.dispatch(updateBulkBatch(data.message));
      store.dispatch(updateWaterfall(data.message)); // Check to see if waterfall needs to be updated.
      break;
    case WebsocketMessageType.UpdateAdmin:
      void store.dispatch(getCustomerStructures());
      break;
    case WebsocketMessageType.UpdateGendec:
      if (data.config) {
        store.dispatch(setGendecConfig(data.config as IGendecSettingsWire));
      } else {
        // If no config is sent, it means something has changed that impacts gendec
        // and we should re-fetch the config to ensure it's up to date.
        void store.dispatch(loadGendecConfig());
      }
      store.dispatch(setGendecStale(true));
      break;
    // case WebsocketMessageType.BasicEventsUpdate:
    //   // @ts-ignore
    //   store.dispatch(webSocketUpdatedEvents(data.updatedEvents));
    //   break;
    case WebsocketMessageType.BasicPairingUpdate:
      store.dispatch(
        // @ts-ignore
        webSocketUpdatePairingEvent(data.updatedEvents, data.updateType)
      );
      break;
    case WebsocketMessageType.PlannedEventUpdate:
    case WebsocketMessageType.PlannedNFAUpdate:
      store.dispatch(webSocketUpdatePlannedPairingEvent(data.updatedEvents, data.updateType));
      break;
    case WebsocketMessageType.BasicNFAUpdate:
      store.dispatch(webSocketUpdateNFAEvent(data.updatedEvents, data.updateType));
      break;
    case WebsocketMessageType.FlightErrorsUpdate: {
      const newErrors = data.message?.newErrors ?? [];
      const fixedErrors = data.message?.fixedErrors ?? [];
      store.dispatch(websocketUpdatedFlightErrors(newErrors, fixedErrors));
      break;
    }
    case WebsocketMessageType.AuditFlightUpdateLink:
      void setAuditFromLink(data.auditEvent).then((z) => store.dispatch(z));
      break;
    case WebsocketMessageType.BasicBookingUpdate:
      store.dispatch(websocketUpdatedBooking(data.updatedEvents, data.updateType));
      break;
    case WebsocketMessageType.CrewLogicModifierUpdate:
      store.dispatch(websocketUpdatedCLM(data.clmEvent));
      break;
    case WebsocketMessageType.AircraftConfigurationUpdate:
      store.dispatch(
        openSnackbar({
          open: true,
          closeDelay: 3000,
          variant: "info",
          message: ((): string => {
            switch (true) {
              case !data.configDiff.oldConfigId && !!data.configDiff.updatedConfig:
                return "Received AircraftConfig create notification";
              case !data.configDiff.updatedConfig && !!data.configDiff.oldConfigId:
                return "Received AircraftConfig delete notification";
              case data.configDiff.updatedConfig && data.configDiff.oldConfigId:
              default:
                return "Received AircraftConfig update notification";
            }
          })(),
        })
      );
      break;
    case WebsocketMessageType.ScheduleValidationUpdate:
      // make a call to fetch what is in the violations collection
      void store.dispatch(getViolations(data?.updatedEvents?.updatedCrewIds));
      break;
    case WebsocketMessageType.RefreshQualifications:
      const update: IRefreshQualifications = data?.update;
      // call update quals
      void store.dispatch(getQualifications(update?.crewIds));
      break;
    case WebsocketMessageType.FileReady:
      if (data?.fileReadyEvent) {
        const { downloadUrl, title } = data.fileReadyEvent as IFileReadyNotification;

        store.dispatch(
          openSnackbar({
            open: true,
            closeDelay: null,
            variant: "success",
            message: `${title} File Ready for `,
            actionURL: downloadUrl,
            actionType: "external-link",
            actionLabel: "DOWNLOAD",
          })
        );
      }
      break;
    case WebsocketMessageType.CrewSchedViolationsStatus: {
      store.dispatch(gotViolationCheckStatus(data?.crewToUpdate));
      break;
    }
    case FLIGHT_PAIRING_STATUS_UPDATE_MESSAGE_TYPE: {
      // Flight pairing status cache changed (crew / pairing / flight change, or a scheduled refresh).
      store.dispatch(applyFlightPairingStatusUpdate(data?.update));
      break;
    }
    case WebsocketMessageType.OpsLinkMessage: {
      if (data?.flightId) {
        store.dispatch(getEventsByFlight({ flightId: data.flightId }));
      }
      break;
    }
    case WebsocketMessageType.OpsPendingMessage: {
      // ENG-453: a pending draft was created/updated - re-fetch the flight's
      // pending list (not the sent/opslink list) so the pvl screen updates live.
      if (data?.flightId) {
        store.dispatch(getPendingByFlight({ flightId: data.flightId }));
      }
      break;
    }
    case WebsocketMessageType.DispatchDeskUpdate: {
      // Re-fetch all desks. The store watcher in dispatchDeskOpsLinkSync
      // automatically re-syncs OpsLink subscriptions & events when
      // desks change.
      store.dispatch(fetchDispatchDesks());
      break;
    }
    case WebsocketMessageType.AircraftMaintenanceUpdate: {
      const update = data.maintenanceUpdate satisfies IWebsocketAircraftMaintenanceUpdate;
      if (update?.registration) {
        store.dispatch(gotAircraftMaintenanceUpdate(update.registration, update.newEvent));
      }
      break;
    }
    case WebsocketMessageType.BidPkgProgressUpdate: {
      if (data?.bidPkgProgress?.bidPkgId) {
        store.dispatch(updatePackageBidPairingCreationProgress(data?.bidPkgProgress));
      }
      break;
    }
    case WebsocketMessageType.ConsoleBroadcastModal:
      if (data?.body?.msg && data?.body?.title) {
        const msg = data.body.msg;
        const title = data.body.title;
        store.dispatch(
          openModal({
            root: {
              data: {
                title: title,
                message: msg,
                buttons: [
                  {
                    label: "OK",
                    handler: () => {
                      store.dispatch(closeModal({ root: { data: null } }));
                    },
                  },
                ],
              },
            },
          })
        );
      }
      break;
    default:
      // Debug.log("Unhandled websocket message!\n" + JSON.stringify(e.data));
      break;
  }
}
